import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { Box, Button, TextField } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ConfirmDelete from '../../../../shared/components/ConfirmDelete';
import CustomDataGrid from '../../../../shared/components/CustomDataGrid';
import { handleError } from '../../../../shared/functions/handleError';
import { useExpenseColumns } from '../../../../shared/hooks/useExpenseColumns';
import { usePagination } from '../../../../shared/hooks/usePagination';
import { IExpense } from '../../../../shared/interfaces/expenses/IExpense';
import { AdminExpenseService } from '../service';

const CompanyExpenses = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [data, setData] = useState<IExpense[] | undefined>(undefined);
  const [selectedExpense, setSelectedExpense] = useState<IExpense | undefined>(
    undefined,
  );
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const {
    pagination,
    count,
    setPagination,
    totalPages,
    setTotalPages,
    setCount,
    changeFilterHandler,
    handleUpdateList,
  } = usePagination({
    perPage: 15,
  });
  const columns = useExpenseColumns(setSelectedExpense, setShowDeleteModal);
  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setSelectedExpense(undefined);
  };
  const deleteHandler = (id?: number) => {
    !!id &&
      AdminExpenseService.delete(id)
        .then((response) => {
          if (response) {
            handleUpdateList();
            enqueueSnackbar(
              t('toasts.successfullyDeleted', { title: selectedExpense?.name }),
              {
                variant: 'success',
              },
            );
            closeDeleteModal();
          }
        })
        .catch((err) => handleError(err));
  };
  useEffect(() => {
    AdminExpenseService.get({ ...pagination, page: pagination?.page + 1 })
      .then((response) => {
        setCount(response?.count);
        setTotalPages(Math.ceil(response?.count / response?.perPage));
        setData(response.data);
      })
      .catch((err) => handleError(err));
  }, [pagination, setTotalPages, setCount]);
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingBottom: '20px',
        }}
      >
        <TextField
          onChange={(e) => {
            changeFilterHandler('name', e.target.value);
          }}
          label={t('general.searchByName')}
          sx={{
            width: { xs: '100%', md: 'auto' },
            paddingBottom: { xs: 2, md: 0 },
          }}
        />

        <Button
          variant={'contained'}
          onClick={() => navigate('/admin/expenses/create')}
          sx={{ width: { xs: '100%', md: 'auto' } }}
        >
          <AddCircleOutlineOutlinedIcon sx={{ marginRight: '5px' }} />
          {t('button.addNewExpense')}
        </Button>
      </Box>
      <CustomDataGrid
        hasNextPage={totalPages < pagination?.page}
        rows={data || []}
        columns={columns}
        rowCount={count}
        pagination={pagination}
        setPagination={setPagination}
        loading={data === undefined}
      />

      <ConfirmDelete
        open={showDeleteModal}
        title={selectedExpense?.name}
        handleClose={closeDeleteModal}
        handleSubmit={() => deleteHandler(selectedExpense?.id)}
      />
    </>
  );
};

export default CompanyExpenses;
